<template>
    <div class="mamMasterIncome white border-radius10 summary-page">
      <div class="content-header">
        <el-row
          :gutter="20"
        >
          <el-col
            :lg="8"
            :md="8"
            :sm="12"
            :xs="24"
          >
            <el-date-picker
              v-if="!realMobile"
              class="header-sub-item"
              style="width: 100%"
              v-model="date"
              @change="toQuery"
              type="daterange"
              :range-separator="$t('root.dateTo')"
              :start-placeholder="$t('root.startDate')"
              :end-placeholder="$t('root.endDate')"
            >
            </el-date-picker>
            <select-date-duration
              class="header-sub-item"
              v-model="date"
            ></select-date-duration>
          </el-col>
          <el-col
            :lg="4"
            :md="8"
            :sm="12"
            :xs="12"
          >
            <el-select
              class="self-select header-sub-item"
              style="width: 100%"
              v-model="momeyType"
              clearable
              :placeholder="$t('types_of_fee')"
              @change="toQuery"
            >
              <el-option
                class="self-mtlist-select"
                v-for="(item,index) in momeyTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
<!--      增加了合计样式-->
      <el-table
              :data="listData"
              v-loading="loading"
              @sort-change="sortChange"
              size="small"
              show-summary
              :empty-text="$t('root.noData')"
              :summary-method="getSummaries"
              :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
      >
          <div class="table-nodata" slot="empty">
              {{$t('root.noData')}}
          </div>
          <el-table-column
                  :label="$t('Payee')"
                  min-width="200px"
                  prop="receivableAccount"
          >
              <template slot-scope="scope">
                  <div class="userName">{{scope.row.masterName}}</div>
                  <div class="login font999">{{scope.row.masterLogin}}
                      <span class="" v-if="scope.row.targetLogin">({{scope.row.targetLogin}}{{$t('Collection')}})</span>
                  </div>
              </template>
          </el-table-column>
          <el-table-column
                  prop="copyNumSum"
                  :label="$t('payment_account')"
                  sortable
                  min-width="200px"
          >
              <template slot-scope="scope">
                  <div class="userName">{{scope.row.copyName}}</div>
                  <div class="login font999">{{scope.row.copyLogin}}
                      <span class="" v-if="scope.row.sourceLogin">({{scope.row.sourceLogin}}{{$t('Pay_on_behalf_of')}})</span>
                  </div>
              </template>
          </el-table-column>
          <el-table-column
                  prop="typesFee"
                  :label="$t('types_of_fee')"
                  sortable
                  min-width="100px"
          >
              <template slot-scope="scope">
                  <span>{{getMoneyType(scope.row)}}</span>
              </template>
          </el-table-column>
          <el-table-column
                  :label="$t('Charging_cycle')"
                  prop="ChargingCycle"
          >
              <template slot-scope="scope">
                  <div class="hasday">
                      <el-tooltip class="item" effect="dark" placement="top">
                          <div slot="content">
                              <p>
                                  {{parseTime(scope.row.beginDate,'{y}-{m}-{d}')}} - {{parseTime(scope.row.endDate,'{y}-{m}-{d}')}}
                                  <span v-if="scope.row.issueNumber">({{scope.row.issueNumber}})</span>
                              </p>
                              <p
                                v-if="scope.row.beginDateLast"
                              >
                                  {{parseTime(scope.row.beginDateLast,'{y}-{m}-{d}')}} - {{parseTime(scope.row.endDateLast,'{y}-{m}-{d}')}}
                                  <span v-if="scope.row.issueNumberLast">({{scope.row.issueNumberLast}})</span>
                              </p>
                          </div>
                          <span v-if="scope.row.days">{{scope.row.days}} {{$t('day')}}</span>
                      </el-tooltip>
                      <span class="" v-if="!scope.row.days">-</span>
                  </div>

              </template>
          </el-table-column>
          <el-table-column
                  prop="price"
                  :label="$t('income')"
                  sortable
          >
              <template slot-scope="scope">
                  <el-tooltip class="item" effect="dark" placement="top">
                      <div slot="content">
                          {{getText(scope.row)}}{{scope.row.leftNum}} * {{scope.row.rightNum}}
                      </div>
                      <span>{{scope.row.price}}</span>
                  </el-tooltip>
              </template>
          </el-table-column>
          <el-table-column
                  prop="transDate"
                  :label="$t('Payment_time')"
                  sortable
                  min-width="100px"
          >
              <template slot-scope="scope">
                  <span>{{parseTime(scope.row.transDate)}}</span>
              </template>
          </el-table-column>
      </el-table>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { parseTime } from '@/utils/index'
  import { isIncludeMinus} from '@/utils/common';
  import initData from '@/mixins/initData';
  export default {
    name: 'mamMasterIncome',
    data() {
      return {
        date: '',
        momeyType: '',
        momeyTypeList: [
          {label: this.$t('management_fee'),value: 1},
          {label: this.$t('Performance_fee'),value: 2},
        ],

        statistics:{
          amountSum: ''
        },


      }
    },
    mixins: [initData],
    created(){
      this.$nextTick(() => {
        this.init();
      })
    },
    watch:{
      date(val){
        // 移动端 todo
        if(this.realMobile){

          this.toQuery();
        }
      }
    },
    computed: {
      ...mapGetters(['language','userInfo','realMobile']),
    },
    methods: {
      parseTime,
      isIncludeMinus,
      phFileter(data){
        return this.$t(data)
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          switch (column.property) {
            case 'receivableAccount':
              sums[index] = this.$t('User.total');
              break;
            case 'copyNumSum':
            case 'typesFee':
            case 'ChargingCycle':
            case 'transDate':
              sums[index] = `-`;
              break;
            case 'price':
              // 总收入
              sums[index] = `${this.statistics.amountSum}`;
              break;
          }
        });
        return sums;
      },
      beforeInit(){
        this.params = {
          mtId: +this.$route.params.mtid,
          page: this.page -1,
          size: this.size,
        }
        // 增加查询条件 todo
        if(this.sort){
          this.params.sort = this.sort;
        }
        if(this.date && this.date.length >= 2){
          this.params.startTime = parseTime(this.date[0]);
          this.params.endTime = parseTime(this.date[1]);
        }
        if(this.momeyType){
          this.params.priceType = this.momeyType;
        }
        this.url = '/crm/reception/queryPaymentTrans';
        return true;
      },
      getMoneyType(row){
        switch (row.priceType) {
          case 0:
            return this.$t('Subscription_fee');
          case 1:
            return this.$t('management_fee');
          case 2:
            return this.$t('Performance_fee');
        }
      },
      getText(row){
        switch (row.priceType) {
          case 1:
            return `${this.$t('Management_fee_ratio')}*${this.$t('Manage_funds')}: `;
          case 2:
            return `${this.$t('Performance_fee_ratio')}*${this.$t('Follow_income')}: `
        }
      }
    },
  };
</script>
<style scoped lang="scss">
    .mamMasterIncome{
      .content-header {
        padding: 20px;
      }
      .header-sub-item {
        margin-bottom: 10px;
      }
    }
</style>
